export default {
  name: "RejectModal",
  props: {
    placement: {
      type: String,
      default: "top-start"
    }
  },
  data: function data() {
    return {
      visible: false,
      rejectType: 2
    };
  },
  watch: {
    visible: function visible(newVal) {
      if (newVal) {
        this.addKeyboardListener();
      } else {
        this.removeKeyboardListener();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeKeyboardListener();
  },
  methods: {
    cancel: function cancel() {
      this.visible = false;
      this.rejectType = 2;
    },
    determine: function determine() {
      if (this.rejectType < 2) {
        this.$message.warning("请选择拒绝通知类型");
      } else {
        this.$emit("reject", this.rejectType);
        this.cancel();
      }
    },
    reject: function reject() {
      this.$emit("reject", 1);
      this.cancel();
    },
    show: function show() {
      this.visible = true;
    },
    handleKeyboardEvent: function handleKeyboardEvent(event) {
      if (event.key === "Enter") {
        this.reject();
      }
    },
    addKeyboardListener: function addKeyboardListener() {
      document.addEventListener("keyup", this.handleKeyboardEvent);
    },
    removeKeyboardListener: function removeKeyboardListener() {
      document.removeEventListener("keyup", this.handleKeyboardEvent);
    }
  }
};